import { RootState } from 'editor/src/store/index';

const getAddonsCategory = (state: RootState) => state.editorModules.addons.data?.results.category;

export default getAddonsCategory;
